import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { HouseholdPreferenceComponentEvent } from './meal-plan-household-preference.interface';
import { QuantitySelectorComponent } from '@woolworthsnz/product';

@Component({
	selector: 'recipe-meal-plan-household-preference',
	templateUrl: './meal-plan-household-preference.component.html',
	styleUrls: ['./meal-plan-household-preference.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [QuantitySelectorComponent]
})
export class MealPlanHouseholdPreferenceComponent {
	@Input() adultValue: number;
	@Input() childValue: number;

	@Output() increment = new EventEmitter<HouseholdPreferenceComponentEvent>();
	@Output() decrement = new EventEmitter<HouseholdPreferenceComponentEvent>();

	public handleIncrement(value: number, type: 'adult' | 'child'): void {
		this.increment.emit({ value, type });
	}

	public handleDecrement(value: number, type: 'adult' | 'child'): void {
		this.decrement.emit({ value, type });
	}
}
